import { Button, message, Spin, Result } from 'antd';
import { useState, useEffect, useContext } from 'react';
import WebLinks from '../api/WebLinks';
import APIUtils from '../api/APIUtils';
import constants from '../constants/constants';
import Cookies from 'js-cookie';
import { CommonContext } from '../Context';
import { trackPageAccess } from '../globalFunctions/GlobalFunctions';

const DownloadFile = (props) => {
    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;
    const cookieValue = sessionStorage.getItem('selectedissubbuyeradmin')?.toString();

    //Variable declaration
    const [showError, setShowError] = useState("");
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        fetchCVDetail()
        trackPageAccess(buyerId,window.location.href)
    }, [])

    const fetchCVDetail = async () => {
        setLoader(true)
        const buyer= cookieValue==="true"?props?.location?.state?.buyerId:buyerId;
        const cvId = props.location.state.cVid
        const userId = props.location.state.userId
        const url = WebLinks.GetCandidateCVDetail + `?buyerId=${buyer}&CvId=${cvId}&UserId=${userId}&loggedInBuyer=${Cookies.get(constants.COOKIE_LOGGED_BUYER_ID)}`;
        const response = await APIUtils.apiCall('GET', url);
        if (!response.isCatch && response.resultObj.statusCode === "2000") {
            downloadCV(response.resultObj.data)
        } else {
            setLoader(false);
            setShowError(response.resultObj.message)
        }
    }

    const downloadCV = async (data) => {
        setLoader(true)
        const url = WebLinks.DownloadCVFile +  `fileName=${data.fileName}`
        const accessToken = Cookies.get(constants.COOKIE_TOKEN)
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            }
        })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', data.cvFileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoader(false)
                message.success('File downloaded successfully');
            })
            .catch(error => {
                setLoader(false)
                message.error('Error downloading file');
            });
    }

    const goToCandidates = () => {
        if(cookieValue==="true"){
            props.history.push({
                pathname: '/multi-candidate-admin',
                state: {
                    state: props.location.state
                }
            });
        }else{
            props.history.push({
                pathname: '/candidates',
                state: {
                    state: props.location.state
                }
            });
        }
    }


    return (
        <Spin spinning={loader}>
            {showError && <Result
                status="error"
                title={showError}
            ></Result>}
            <Button type="primary" key="goBack" onClick={goToCandidates}>Go back</Button>

        </Spin>
    );
};

export default DownloadFile;